export default function CookiePolicy() {
    return (
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <h1 className="mb-4">Cookie Policy</h1>
            <p>
              We use essential cookies to ensure our platform functions properly. Optional analytics cookies help us improve your experience.
            </p>
            <p>
              You can manage your preferences at any time via the cookie banner or by adjusting your browser settings.
            </p>
            <p>
              No third-party advertising cookies are used on our platform.
            </p>
          </div>
        </div>
      </div>
    );
  }